import { combineReducers } from "redux";

import authReducer from "./authReducer.js";
import locationReducer from "./locationReducer.js";

export default combineReducers({
  auth: authReducer,
  location: locationReducer,
});
